<template>
    <div class="shadow-md p-3 font-primary min-h-[120vh]">
      <b>Mis Pedidos</b> <br>
      <div v-show="pedHistoricos">
        <table class="table table-striped table-sm text-sm">
          <thead>
            <tr>
              <th scope="col">Nro WEB</th>
              <th scope="col">Nro Pedido</th>
              <th scope="col">Direccion</th>
              <th scope="col">Fecha</th>
              <th scope="col">Cliente</th>
              <th scope="col">Total</th>
              <th scope="col">Cant. items</th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody v-if="pedHistoricos.length > 0">
            <tr v-for="(ped, key) in pedHistoricos" class="px-0" :key="key">
              <td>{{ ped.IDCON_PED }}</td>
              <td>{{ ped.NUMERO_PED }}</td>
              <td>{{ ped.DIRECCION_PED }}</td>
              <td>{{ formatDate(ped.FECHA_CARGA_PED) }}</td>
              <td>{{ ped.razon }}</td>
              <td>{{ ped.IMPORTE_CP.toFixed(2) }}</td>
              <td>{{ ped.items.length }}</td>
              <td><button class="btn btn-outline-primary btn-sm" @click="verItems(ped.items)">Ver Items</button></td>
              <td>
                  <button class="btn btn-outline-success btn-sm" :disabled="cargando" @click="repetirPedido(ped)">Repetir pedido</button>
                  <button class="btn btn-outline-success btn-sm" :disabled="cargando" @click="repetirPedidoCambioCli(ped)">a otro cliente</button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td>No hay pedidos aun..</td>
            </tr>
          </tbody>
        </table>
      </div>



      <div class="modal" id="itemsPed">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            
            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Items del pedido</h4>
            </div>
            
            <!-- Modal body -->
            <div class="modal-body">
              <table class="table table-striped table-sm text-sm">
                <thead>
                  <tr>
                    <th scope="col">Codigo</th>
                    <th scope="col">Descripcion</th>
                    <th scope="col">Precio unitario</th>
                    <th scope="col">cantidad</th>
                    <th scope="col">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in items" class="px-0" :key="key">
                    <td>{{ item.CODIGO_ART }}</td>
                    <td>{{ item.DESCRIP_ART }}</td>
                    <td>${{ item.PRECIO_LPI.toFixed(2) }}</td>
                    <td>{{ item.CANTIDAD_PEDI }}</td>
                    <td>${{ (Number(item.PRECIO_LPI) * Number(item.CANTIDAD_PEDI)).toFixed(2) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          
            <!-- Modal footer -->
            <div class="modal-footer">
                <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cancelar</button>
            </div>

          </div>
        </div>
      </div>

      <div class="modal" id="borrarCarrito">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            
            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Repetir pedido</h4>
            </div>
            
            <!-- Modal body -->
            <div class="modal-body">
             <p>Actualmente posee articulos en el carrito, desea eliminarlos?</p>
            </div>
          
            <!-- Modal footer -->
            <div class="modal-footer">
                <button class="btn btn-success" @click="borrarYrepetir()">Borrar articulos y repetir pedido</button>
                <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cancelar</button>
            </div>

          </div>
        </div>
      </div>
      
      <div class="modal" id="repetirPedDistUsu">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            
            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Repetir pedido a usuario:</h4>
            </div>
              
              <!-- Modal body -->
            <div class="modal-body">
              <div class="flex flex-wrap justify-center items-center p-2">
                <input type="text" class="form-control w-44" v-model="filtroClientes" @change="updateIdcli()" placeholder="Buscar cliente..">
                <div class="flex flex-wrap justify-center items-center p-2">
                  <p>Cliente: </p>
                  <select placeholder="Seleccione un cliente" class="form-select w-72" v-model="idcli">
                    <option value="" disabled selected hidden>Seleccione un cliente</option>
                    <option v-for="(ex, key) in clientesFiltrados" :key="key" :value="ex.id">{{ ex.descripcion }}</option>
                  </select>
                </div>
              </div> 
            </div>
          
            <!-- Modal footer -->
            <div class="modal-footer">
                <button class="btn btn-success" @click="repetirAusu()">repetir pedido</button>
                <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cancelar</button>
            </div>

          </div>
        </div>
      </div>

    </div>
  </template>
  
  <script>
import pedidosService from '@/services/pedidos.service';
import usuarioService from '@/services/usuario.service';
  export default {
    data() {
      return {
        pedHistoricos: [],
        items: [],
        cargando: false,
        itemsRepetir: [],
        idcli: '',
        index: 0,
        //idcli: '',
        filtroClientes: '',
        clientes: [],
        pedArepetir: []
      };
    },
    mounted() {
        this.getMisPedidos(0)
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeUnmount() {
       window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        repetirAusu() {
          this.pedArepetir.IDCLI_PED = this.idcli
          window.$('#repetirPedDistUsu').modal('hide')
          this.repetirPedido(this.pedArepetir)
        },
        repetirPedidoCambioCli(ped) {
          this.pedArepetir = ped
          if (!this.esSupervisor && this.esVendedor) {
            this.cargarClientes();
          }
          if (this.esSupervisor) {
            this.cargarTodosLosClientes()
          }
          // this.cargarClientes()
          window.$('#repetirPedDistUsu').modal('show')
        },  
        cargarClientes() {
          usuarioService.getClientes(this.$root.user.id)
            .then((res) => {
              this.clientes = res.data.map(c => ({
                id: c.ID_CLI,
                descripcion: c.RAZONSOCIAL_CLI
              }))
              this.idcli = this.clientes[0].id
            })
            .then(() => {
              this.itemsCarrito()
            })
            .catch(err => {
              console.log(err)
            })
        },
        cargarTodosLosClientes() {
          usuarioService.getAllClientes(this.$root.user.id)
            .then((res) => {
              this.clientes = res.data.map(c => ({
                id: c.ID_CLI,
                descripcion: c.RAZONSOCIAL_CLI
              }))
              this.idcli = this.clientes[0].id
            })
            .then(() => {
              this.itemsCarrito()
            })
            .catch(err => {
              console.log(err)
            })
        },
        updateIdcli() {
          this.idcli = this.clientesFiltrados[0].id
          this.itemsCarrito()
        },
        itemsCarrito() {
          var user = JSON.parse(localStorage.getItem("user"));
          pedidosService
            .getItemsCarritoClienteSimple(user.id, this.idcli)
            .then((res) => {
              console.log(res)
            })
            .catch((err) => {
              console.log(err);
            });          
        },
        repetirPedido(ped) {
          this.itemsRepetir = []
          if (!this.esVendedor) {
            pedidosService.getCountItemsCarrito(this.$root.user.id)
              .then((res) => {
                this.res(res, ped)
              })
              .catch((err) => {
                console.log(err)
              })
          } else {
            this.idcli = ''
            pedidosService.getCountItemsCarritoCliente(this.$root.user.id, ped.IDCLI_PED)
              .then((res) => {
                this.idcli = ped.IDCLI_PED
                this.res(res, ped)
              })
              .catch((err) => {
                console.log(err)
              })
          }
        },
        res(res, ped) {
          if(res.data > 0) {
            this.pedRepetir = ped
            window.$('#borrarCarrito').modal('show')
          } else {
            this.repetirItems(ped)
          }
        },
        borrarYrepetir() {
          window.$('#borrarCarrito').modal('hide')
          if (this.esVendedor) {
            pedidosService.deleteCarritoUsuCli(this.$root.user.id, this.esVendedor ? this.idcli : null)
              .then(() => {
                this.repetirItems(this.pedRepetir)
              })
              .catch((err) => {
                console.log(err)
              })
          }
        },
        repetirItems(ped) {
          this.cargando = true;
          console.log(ped.items)
          ped.items.forEach(item => {
            var itm = {
                id: item.id_ic ? item.id_ic : null,
                idart: item.IDART_PEDI,
                cantidad: item.CANTIDAD_PEDI,
                obs: item.OBS1_PEDI ? item.OBS1_PEDI : null,
                idcli: this.esVendedor ? this.idcli : null
              };
            pedidosService
              .postItemsCarrito(itm)
              .catch((err) => {
                console.log(err);
              });
          })
          this.cargando = false
          this.$router.push('/carrito?id=' + this.idcli)
          this.$root.alertSucces = true
          this.$root.isAlertVisible = true
        },
        verItems(items) {
            this.items = items.sort((a, b) => {
                if (a.CODIGO_ART < b.CODIGO_ART) {
                    return -1; // a comes before b
                }
                if (a.CODIGO_ART > b.CODIGO_ART) {
                    return 1; // a comes after b
                }
                return 0; // a and b are equal
            });
            window.$('#itemsPed').modal('show')
        },
        getMisPedidos(index) {
          this.cargando = true
            pedidosService.getMisPedidos(index)
                .then((res) => {
                  if (res.data.length < 1) {
                    this.index--
                  } else {
                    console.log(res.data)
                    this.pedHistoricos.push(...res.data)
                  }
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                  this.cargando = false
                })
        },
        handleScroll() {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const scrollPercentage = (scrollY / (pageHeight - windowHeight)) * 100;
        if (scrollPercentage >= 60 && !this.cargando) {
          console.log("Scrolled to 60% of the page, index: " + this.index);
          if (!this.cargando) {
            this.index = this.index + 1;
            this.getMisPedidos(this.index)
          }
        }
      },
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
    },
    computed: {
      esVendedor() {
        return this.$root.user.tipo != "cliente";
      },
      esSupervisor() {
        return this.esVendedor && ['admin', 'supervisor'].includes(this.$root.user.tipo)
      },
      clientesFiltrados() {
        if (!this.filtroClientes) {
          return this.clientes
        } else {
          return this.clientes.filter(x => x.descripcion.toLowerCase().includes(this.filtroClientes.toLocaleLowerCase()))
        }
      },
    },
  };
  </script>

